export const PolicyCancellationDelayReasonValue = {
  AGENT_ERROR: 'AGENT_ERROR',
  SYSTEM_ERROR: 'SYSTEM_ERROR',
  AGENT_OUT_OF_OFFICE: 'AGENT_OUT_OF_OFFICE',
  OTHER: 'OTHER',
};

export const policyCancellationDelayReasons = [
  {
    value: PolicyCancellationDelayReasonValue.AGENT_ERROR,
    label: 'POLICY_CANCELLATION.delayReason.agentError',
  },
  {
    value: PolicyCancellationDelayReasonValue.SYSTEM_ERROR,
    label: 'POLICY_CANCELLATION.delayReason.systemError',
  },
  {
    value: PolicyCancellationDelayReasonValue.AGENT_OUT_OF_OFFICE,
    label: 'POLICY_CANCELLATION.delayReason.agentOutOfOffice',
  },
  {
    value: PolicyCancellationDelayReasonValue.OTHER,
    label: 'POLICY_CANCELLATION.delayReason.other',
  },
];
